const BeerIcon = ({ color, className }: { color: string; className: string }) => (
  <svg className={className} width="13" height="14" viewBox="0 0 13 14" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0.5H13L10.92 7.5H2.08L0 0.5Z" />
    <path d="M3 9.5H10L8.88 13.5H4.12L3 9.5Z" />
  </svg>
);

export default BeerIcon;
